import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-bottom: 10px;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  path {\n    &[fill] {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: #486b4d;\n  padding: 9px;\n  border-radius: 50%;\n  width: 42px;\n  height: 42px;\n  vertical-align: bottom;\n  display: inline-flex;\n  margin-left: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: calc(100% - 150px);\n  background-color: ", ";\n  padding: 20px;\n  width: fit-content;\n  border-radius: ", ";\n  color: ", ";\n  font-size: 14px;\n  display: inline-flex;\n  text-align: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  text-align: right;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { AcornsIcon } from '@acorns/icons';
import { USER_CHAT_MESSAGE } from './testIDs';
var MessageContainerBox = styled.div(_templateObject());
var InternalMessageBox = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.slate;
});
var FaceContainer = styled.div(_templateObject3());
var Face = styled(AcornsIcon)(_templateObject4(), function (props) {
  return props.theme.colors.white;
});
var MessageContainer = styled.div(_templateObject5());
export var SentMessage = function SentMessage(_ref) {
  var index = _ref.index,
      message = _ref.message;
  return /*#__PURE__*/React.createElement(MessageContainerBox, {
    "data-testid": "".concat(USER_CHAT_MESSAGE, "_").concat(index)
  }, /*#__PURE__*/React.createElement(MessageContainer, null, /*#__PURE__*/React.createElement(InternalMessageBox, null, message.text), /*#__PURE__*/React.createElement(FaceContainer, null, /*#__PURE__*/React.createElement(Face, {
    icon: AcornsIcon.Icon.UtilityFaceFv
  }))));
};